<template>
  <div class="home-name-week" :class="[deviceType]">
    <div class="week-header">
      <div class="week-dot"></div>
      <div class="week-title">Names of The Week</div>
    </div>
    <div class="week-cards">
      <router-link v-for="(card, index) in nameCards" :key="index"
        :to="`/names/${card.name.toLowerCase()}/${card.id}`" tag="div" class="name-card-link">
        <div class="name-card" @mouseenter="hoveredCard = index" @mouseleave="hoveredCard = null"
          :class="{ 'active': hoveredCard === index }">
          <div class="card-header">
            <div class="card-icon">
              <img :src="card.genderIcon" alt="gender icon" />
            </div>
            <div class="card-type">{{ card.type }}</div>
          </div>
          <div class="card-name">{{ card.name }}</div>
          <div class="card-description">{{ card.description }}</div>
          <div class="card-action">
            <div class="see-more-button" :class="{ 'active': hoveredCard === index }">
              <span>See More</span>
              <img src="@/assets/default/arrow-right-small.svg" alt="arrow" />
            </div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'HomeNameWeek',
  data () {
    return {
      hoveredCard: null,
      nameCards: []
    };
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'domainConfig'
    ])
  },
  mounted () {
    this.fetchNameOfWeek();
  },
  methods: {
    fetchNameOfWeek () {
      // 从domainConfig获取origin参数
      const origin = this.domainConfig?.origin || '';

      // 请求/name/week接口
      this.$global.server.postAPI({
        method: 'get',
        params: {
          origin: origin
        },
        url: '/name/week',
      })
        .then(response => {
          if (response && response.data && response.data.list) {
            // 将接口返回数据转换为组件所需格式
            this.nameCards = response.data.list.map(item => {
              return {
                type: item.gender === 'Boy' ? 'Boy Name of the Week' : 'Girl Name of the Week',
                name: item.name || '',
                description: item.description || '',
                genderIcon: item.gender === 'Boy'
                  ? require('@/assets/icons/male.svg')
                  : item.gender === 'Unisex'
                    ? require('@/assets/icons/unsex.svg')
                    : require('@/assets/icons/female.svg'),
                id: item.id || ''
              };
            });
            console.log('本周名字获取成功:', response.data.list);
          }
        })
        .catch(error => {
          console.error('获取本周名字失败:', error);
        });
    },
    navigateToNameDetail (index) {
      const card = this.nameCards[index];
      if (card) {
        const formattedName = card.name.toLowerCase();

        this.$router.push(`/names/${formattedName}/${card.id}`);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.home-name-week {
	padding: rem(60) rem(180);
	display: flex;
	flex-direction: column;
	gap: rem(24);
	align-items: flex-start;
	justify-content: flex-start;
	position: relative;

	.week-header {
		padding: 0;
		display: flex;
		flex-direction: row;
		gap: rem(16);
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		position: relative;

		.week-dot {
			background: #a31984;
			border-radius: rem(100);
			width: rem(8);
			height: rem(4);
			position: relative;
		}

		.week-title {
			color: #03133a;
			text-align: left;
			font-size: rem(28);
			line-height: rem(28);
			font-weight: 900;
			position: relative;
		}
	}

	.week-cards {
		padding: 0;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		align-self: stretch;
		position: relative;
		gap: rem(24);

		.name-card-link {
			text-decoration: none;
			width: 50%;
		}

		.name-card {
			background: linear-gradient(101.3deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.6) 70%, rgba(255, 255, 255, 0) 100%);
			border-radius: rem(36);
			border: rem(1) solid rgba(3, 19, 58, 0.04);
			padding: rem(32) rem(32) rem(24) rem(32);
			display: flex;
			flex-direction: column;
			gap: rem(16);
			align-items: flex-start;
			justify-content: flex-start;
			width: 100%;
			position: relative;
			box-shadow: 0 rem(2) rem(4) 0 rgba(0, 0, 0, 0.08);
			transition: all 0.3s ease;
			cursor: pointer;

			&.active {
				border-color: #a31984;
				box-shadow: none;
			}

			.card-header {
				display: flex;
				flex-direction: row;
				gap: rem(8);
				align-items: center;
				justify-content: flex-start;
				position: relative;

				.card-icon {
					width: rem(16);
					height: rem(16);
					position: relative;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.card-type {
					color: #e54cba;
					text-align: left;
					font-size: rem(18);
					line-height: rem(20);
					font-weight: 700;
					position: relative;

					.name-card:nth-child(2) & {
						color: #38abff;
					}
				}
			}

			.card-name {
				color: #03133a;
				text-align: left;
				font-size: rem(24);
				line-height: rem(24);
				font-weight: 900;
				position: relative;
			}

			.card-description {
				color: #374674;
				text-align: left;
				font-size: rem(13);
				line-height: rem(20);
				font-weight: 400;
				position: relative;
				align-self: stretch;
				display: -webkit-box;
				-webkit-line-clamp: 3;
				-webkit-box-orient: vertical;
				overflow: hidden;
			}

			.card-action {
				display: flex;
				flex-direction: column;
				align-items: flex-end;
				justify-content: center;
				align-self: stretch;
				position: relative;
				margin-top: auto;

				.see-more-button {
					border-radius: rem(12);
					border: rem(1) solid #a31984;
					padding: rem(8) rem(16);
					display: flex;
					flex-direction: row;
					gap: rem(8);
					align-items: center;
					justify-content: flex-start;
					position: relative;
					transition: all 0.3s ease;
					cursor: pointer;

					span {
						color: #a31984;
						text-align: center;
						font-size: rem(12);
						line-height: rem(12);
						font-weight: 700;
						position: relative;
					}

					img {
						width: rem(6);
						height: rem(10);
					}

					&.active {
						background: #a31984;

						span {
							color: #ffffff;
						}

						img {
							filter: brightness(0) invert(1);
						}
					}
				}
			}
		}
	}
}

.detect_deviece_mobile {
	.home-name-week {
		padding: rem(60) 0;

		.week-header {
			padding: 0 rem(16);
		}

		.week-cards {
			padding: 0 rem(16);
			flex-direction: column;
			gap: rem(16);

			.name-card-link {
				width: 100%;
			}

			.name-card {
				width: 100%;
			}
		}
	}
}
</style> 